import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import "@/index-white.css";
import AppWhite from "@/AppWhite";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <AppWhite />
  </React.StrictMode>,
);
